import React from 'react';
import { useTheme, Box, Unstable_Grid2 as Grid } from '@mui/material';
import SnapshotsBronzeCard from '../snapshots-bronze-card';
import SnapshotsDownloadsCard from '../snapshots-downloads-card';
import SnapshotsActionsCard from '../snapshots-actions-card';

interface ISnapshotsListRowTemplateProps {
  snapshot: ISnapshot;
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>;
  setSnapshotForDelete: React.Dispatch<React.SetStateAction<ISnapshot | null>>;
}

export default function SnapshotsListRowTemplate (props: ISnapshotsListRowTemplateProps) {

  const theme = useTheme();
  
  return (
    <Box sx={{ bgcolor: theme.palette.grey[100], overflow: 'hidden'}}>
      <Grid container spacing={1} sx={{ m: .5 }}>
        <Grid xs={6}>
          <SnapshotsBronzeCard 
            snapshot={props.snapshot}
            setIsDownloading={props.setIsDownloading}  />
        </Grid>
        <Grid xs={3}>
          <SnapshotsDownloadsCard 
            snapshot={props.snapshot} 
            setIsDownloading={props.setIsDownloading} />
        </Grid>
        <Grid xs={3}>
          <SnapshotsActionsCard 
            snapshot={props.snapshot}
            setIsDownloading={props.setIsDownloading}
            setSnapshotForDelete={props.setSnapshotForDelete}  />
        </Grid>
      </Grid>
    </Box>
  );
}

// import { Close as CloseIcon, Check as CheckIcon, FileDownload as FileDownloadIcon, Delete as DeleteIcon, PlayCircle as PlayCircleIcon, OpenInNew as OpenInNewIcon } from '@mui/icons-material';
// import { useAmaWorkflowContext } from '../../../../context/ama-workflow-provider';
// import { useS3Manager } from '../../../../hooks/useS3Manager';
// import { SnapshotStatus } from '../../../../data/enums';

  // const { runSnapshotSilverJob } = useAmaWorkflowContext();    
  // const { downloadObject, listObjectsAtPrefix  } = useS3Manager({ bucketName: process.env.REACT_APP_AWS_S3_DATA_LAKE_BUCKET! }); 

  // const getFileCollectedIcon = (isCollected: boolean | undefined) => {
  //   if (isCollected) return (<CheckIcon sx={{ fontSize: '1rem'}}/>);
  //   return (<CloseIcon sx={{ fontSize: '1rem'}}/>);
  // };

  // const sourceFiles = props.snapshot?.SourceFiles?.sort((a,b) => {
  //   const isCollectionCompleteA = a.IsCollectionComplete || false;
  //   const isCollectionCompleteB = b.IsCollectionComplete || false;
  //   return Number(isCollectionCompleteA) - Number(isCollectionCompleteB);
  // }) || [];

  // const RenderBronzeDownloadColumn = (snapshot: ISnapshot, item: IManifestItem) => {
    
  //   const clickHandler = async () => {              
  //     const prefix = `${process.env.REACT_APP_AWS_S3_DATA_LAKE_ROOT_PATH}/bronze/ama_${snapshot.ClientId}/snapshot=${snapshot.SnapshotDate}/data/${item.Category}`;
  //     const files = await listObjectsAtPrefix(prefix);
  //     const key = files.pop()?.BronzePath;
  //     if (!key) return;
  //     props.setIsDownloading(true);
  //     await downloadObject(key);
  //     props.setIsDownloading(false);
  //   };

  //   if (!item.IsCollectionComplete) {
  //     return (        
  //       <IconButton 
  //         aria-label="Download Bronze File."
  //         sx={{ color: theme.palette.grey[600]}}
  //         disabled={!item.IsCollectionComplete}
  //         onClick={clickHandler}>
  //         <FileDownloadIcon />
  //       </IconButton>);
  //   } else {
  //     return (
  //       <Tooltip title="Download Bronze File.">
  //         <IconButton 
  //           aria-label="Download Bronze File."
  //           sx={{ color: theme.palette.grey[600]}}
  //           disabled={!item.IsCollectionComplete}
  //           onClick={clickHandler}>
  //           <FileDownloadIcon />
  //         </IconButton>
  //       </Tooltip>);
  //   }
  // };

  // const RenderSchemaLinkColumn = (snapshot: ISnapshot, item: IManifestItem) => {

  //   const clickHandler = async () => {              

  //     if (!snapshot.BronzeDb || !item.BronzeTableName) return;

  //     // Open SchemaView in new tab
  //     const url = `${window.location.origin}/schema?db=${encodeURIComponent(snapshot.BronzeDb)}&table=${encodeURIComponent(item.BronzeTableName)}`;        
  //     window.open(url, '_blank');

  //     // Example) Opening AWS console
  //     // window.open(
  //     //   `https://us-east-2.console.aws.amazon.com/glue/home?region=us-east-2#/v2/data-catalog/tables/view/${item.BronzeTableName}?database=${snapshot.BronzeDb}&catalogId=665302697606&versionId=latest`, 
  //     //   '_blank')
  //   };

  //   if (!item.IsCollectionComplete) {
  //     return (        
  //       <IconButton 
  //         aria-label="Open Bronze schema."
  //         sx={{ color: theme.palette.grey[600]}}
  //         disabled={!item.BronzeTableName}>
  //         <OpenInNewIcon sx={{ fontSize: 'medium' }}/>
  //       </IconButton>);
  //   } else {
  //     return (
  //       <Tooltip title="Open Bronze schema.">
  //         <IconButton 
  //           aria-label="Open Bronze schema."
  //           sx={{ color: theme.palette.grey[600]}}
  //           disabled={!item.BronzeTableName}
  //           onClick={clickHandler}>
  //           <OpenInNewIcon sx={{ fontSize: 'medium' }}/>
  //         </IconButton>
  //       </Tooltip>);
  //   }
  // };

  // const handleDeleteButtonClick = () => {
  //   props.setSnapshotForDelete({ 
  //     ClientId: props.snapshot.ClientId, 
  //     SnapshotDate: props.snapshot.SnapshotDate, 
  //     Status: '', 
  //     IsCollectionComplete: false, 
  //     Jobs: []});
  // };

  // const handleSnapshotRerunClick = () => {
  //   runSnapshotSilverJob(props.snapshot.ClientId, props.snapshot.SnapshotDate);
  // };

  // const buttonStyle = {
  //   backgroundColor: 'white', 
  //   color: theme.palette.grey[500],
  //   borderColor: theme.palette.grey[400],    
  //   '&:hover': { 
  //     color: theme.palette.grey[500],
  //     backgroundColor: theme.palette.grey[100],
  //     borderColor: theme.palette.grey[400],   
  //   }, 
  // };

  // const tableHeaderStyle = {
  //   color: theme.palette.text.secondary,
  //   fontSize: '0.7rem', 
  //   fontWeight: '900',
  //   height: '40px',
  //   paddingTop: 0,
  //   paddingBottom: 0
  // };

  // const tableCellStyle = {
  //   color: theme.palette.text.secondary,
  //   fontSize: '0.7rem',
  //   height: '40px',
  //   paddingTop: 0,
  //   paddingBottom: 0,
  // };

  // const getRunSilverButtonLabel = (snapshot: ISnapshot) => {
  //   if (snapshot.Status === SnapshotStatus.SilverTransformed) return 'RERUN SILVER JOB';
  //   return 'RUN SILVER JOB';
  // };

// return (
//   <Box
//     sx={{   
//       display: 'flex', flexDirection: 'column',
//       bgcolor: theme.palette.grey[100] 
//     }}>


//     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', ml: 2, mt: 2, mb: 3 }}>
//       <ButtonGroup 
//         variant="outlined" 
//         aria-label="Basic button group"
//         sx={{ width: 'auto' }}>
        
//         {/* Delete snapshot button */}
//         <Tooltip title="Delete snapshot (this will remove all files from Bronze and Silver).">
//           <Button 
//             sx={buttonStyle}
//             onClick={handleDeleteButtonClick}
//             startIcon={<DeleteIcon />}>
//             DELETE SNAPSHOT
//           </Button>
//         </Tooltip>

//         {/* Run silver job button */}
//         <Tooltip title="Run Silver Glue Job (this will overwrite existing Silver data).">
//           <Box component='div'>
//             <Button 
//               sx={buttonStyle} 
//               onClick={handleSnapshotRerunClick}
//               startIcon={<PlayCircleIcon />}
//               disabled={!(props.snapshot.Status === SnapshotStatus.SilverTransformed || props.snapshot.Status === SnapshotStatus.SilverTransformError || props.snapshot.Status === SnapshotStatus.BronzeCollcted || props.snapshot.Status === SnapshotStatus.GoldTransformed || props.snapshot.Status === SnapshotStatus.GoldTransformErrror)}>
//               {getRunSilverButtonLabel(props.snapshot)}
//             </Button>
//           </Box>
//         </Tooltip>



//       </ButtonGroup>
//     </Box>

//     <Typography variant="h5" sx={{ fontSize: '0.7rem', mx: 2, mb:1, textTransform: 'uppercase', letterSpacing: '0.1em' }} color="text.secondary">
//       File Collection (Bronze)
//     </Typography>

//     <Grid item xs={12} sx={{ mx: 2, mb: 2, flexWrap: 'nowrap' }}>
      // <TableContainer component={Paper}>
      //   <Table sx={{ width: '100%' }} aria-label="simple table">
      //     <TableHead>
      //       <TableRow>
      //         <TableCell align="left" style={{ width: 'auto', minWidth: '200px', ...tableHeaderStyle }}>File</TableCell>            
      //         <TableCell align="left" style={{ width: 'auto', minWidth: '100px', ...tableHeaderStyle }}>Error</TableCell>
      //         <TableCell align="center" style={{ width: 'auto', minWidth: '125px', ...tableHeaderStyle }}>File Collected</TableCell>  
      //         <TableCell align="center" style={{ width: 'auto', minWidth: '125px', ...tableHeaderStyle }}>&nbsp;</TableCell>   
      //         <TableCell align="left" style={{ width: 'auto', minWidth: '200px', ...tableHeaderStyle }}>Status</TableCell>  
      //         <TableCell align="center" style={{ width: 'auto', minWidth: '50px', ...tableHeaderStyle }}>Bronze</TableCell>
      //         <TableCell align="center" style={{ width: 'auto', minWidth: '50px', ...tableHeaderStyle }}>&nbsp;</TableCell>    
      //         <TableCell align="center" style={{ width: 'auto', minWidth: '100px', ...tableHeaderStyle }}>Schema</TableCell>            
      //       </TableRow>
      //     </TableHead>
      //     <TableBody>
      //       {sourceFiles.map((item, index) => (
      //         <TableRow key={item.Category} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>                  
      //           <TableCell align="left" style={{...tableCellStyle}}>{item.Category}</TableCell>    
      //           <TableCell align="left" style={{...tableCellStyle}}>
      //             <Tooltip title={item.ErrorDetail}>
      //               <Box component='span'>{item.Error}</Box>
      //             </Tooltip>
      //           </TableCell>       
      //           <TableCell align="center" style={{...tableCellStyle}}>{getFileCollectedIcon(item.IsCollectionComplete)}</TableCell>
      //           <TableCell align="center" style={{...tableCellStyle}}>&nbsp;</TableCell>
      //           <TableCell align="left" style={{...tableCellStyle}}>{item.Status}</TableCell>
      //           <TableCell align="center" style={{...tableCellStyle}}>
      //             {RenderBronzeDownloadColumn(props.snapshot, item)}
      //           </TableCell>
      //           <TableCell align="center" style={{...tableCellStyle}}>&nbsp;</TableCell>
      //           <TableCell align="center" style={{...tableCellStyle}}>
      //             {RenderSchemaLinkColumn(props.snapshot, item)}
      //           </TableCell>
      //         </TableRow>
      //       ))}
      //     </TableBody>
      //   </Table>
      // </TableContainer>
//     </Grid>
//   </Box>
// );

          {/* Capture census button */}
          {/* <Button 
            sx={buttonStyle} 
            disabled={true}>
            CAPTURE CENSUS
          </Button> */}


      {/* <Typography variant="h5" sx={{ fontSize: '0.7rem', mx: 2, mt: 2, mb:1, textTransform: 'uppercase', letterSpacing: '0.1em' }} color="text.secondary">
        Snapshot Operations
      </Typography> */}